<template>
  <div class="relative" v-if="!isMobileApp">
    <AthleteSectionSubheading>Test Scores</AthleteSectionSubheading>
    <div class="flex flex-row flex-wrap mb-8 -mx-3">
      <div class="w-full px-3 mb-3 md:w-1/2">
        <AthleteTestScoreCard title="sat" :value="0" :scale="1600" />
      </div>
      <div class="w-full px-3 mb-3 md:w-1/2" v-if="!['sm', 'xs'].includes($mq)">
        <AthleteTestScoreCard title="psat" :value="0" :scale="1600" />
      </div>
    </div>
    <div
      class="absolute left-0 right-0 flex flex-col items-center justify-start w-full h-full py-12 mx-auto text-center gray-fade"
      style="bottom: -80px"
    >
      <div class="absolute top-0 mt-16 sm:mt-24 w-full mx-auto">
        <h2 class="p-6 mb-4 ds-text-2xl font-bold text-gray-900">
          College Coach? Log in to see {{ user.firstName }}'s full profile!
        </h2>
        <a href="/login" class="inline-block">
          <Button text="Log In as Coach" emphasis="high" />
        </a>
        
        <a :href="$domain.config('coaches.signup.landing_page_url')" class="block pt-3 ds-text-base font-medium cursor-pointer">
          Hey coach, don't use {{ $domain.config('title_name') }} yet?
          <br />Get started here.
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AthleteTestScoreCard from "../ProfileSections/Academic/AthleteTestScoreCard.vue";
import AthleteSectionSubheading from "../AthleteSectionSubheading";
import { Button } from '@sportsrecruits/playbook';
import SRCookies from "@/services/cookies";

export default {
  components: {
    AthleteTestScoreCard,
    AthleteSectionSubheading,
    Button,
  },
  computed: {
    ...mapState({
      user: (state) => state.athleteProfile.user,
    }),
    isMobileApp() {
      return SRCookies.isMobileSession()
    },
  },
};
</script>

<style scoped>
.gray-fade {
  background: rgb(240, 241, 243);
  background: linear-gradient(
    0deg,
    rgba(240, 241, 243, 1) 0%,
    rgba(240, 241, 243, 1) 80%,
    rgba(240, 241, 243, 0) 100%
  );
  display: flex;
  justify-content: center;
}
</style>
